import { PredictionType } from "../../../utils/enums";
import moment from "moment-timezone"

import { NormalizedPredictionKind } from "./enums";
export function normalizePredictionData(data) {
    if (!data) return { type: NormalizedPredictionKind.NONE };


    if (data.predictions?.moonChangePredictions || data?.moonChangeSummaries) {
        return {
            type: NormalizedPredictionKind.MOON_CHANGE,
            before: {
                summary: data.moonChangeSummaries?.beforeMoonChange || null,
                predictions: data.predictions?.beforeMoonChange || []
            },
            after: {
                summary: data.moonChangeSummaries?.afterMoonChange || null,
                predictions: data.predictions?.afterMoonChange || []
            }
        };
    }

    if (data.predictions) {
        return {
            type: NormalizedPredictionKind.NORMAL,
            summary: data.summary,
            predictions: data.predictions
        };
    }


    return { type: NormalizedPredictionKind.UNKNOWN };
}


// export function categorizePredictions(predictions = []) {
//     if (!predictions || !predictions.length) return [];
//     return predictions

//     const grouped = predictions.reduce((acc, p) => {
//         const category = p.category || "OTHER";

//         if (!acc[category]) {
//             acc[category] = [];
//         }

//         acc[category].push(p);
//         return acc;
//     }, {});

//     return Object.entries(grouped).map(([category, items]) => ({
//         category,
//         predictions: items
//     }));
// }


export const formatDayInterval = (interval, timezone) => {
    if (!interval || !interval.start || !interval.end)
        return null;

    const start = moment(interval.start)
        .tz(timezone)
        .format("DD MMM yyyy, h:mm A");
    const end = moment(interval.end)
        .tz(timezone)
        .format("DD MMM yyyy, h:mm A");
    return { start, end };
};

export const formatInterval = (interval, timezone) => {
    return {
        start: moment(interval.start).tz(timezone).format("DD MMM yyyy"),
        end: moment(interval.end).tz(timezone).format("DD MMM yyyy"),
    };
};

export const getFormattedInterval = (interval, timezone, predictionType) => {
    if (predictionType === PredictionType.DAY) {
        return formatDayInterval(interval, timezone);
    }
    return formatInterval(interval, timezone);
};